<section [formGroup]="formGroup" class="layout-grid">
    <div class="payment-method-details__bank-info">
        <mat-form-field class="echeck__name" appearance="standard" floatLabel="always">
            <mat-label>{{ ECHECK_FIELDS.checkname }}</mat-label>
            <input matInput
                [formControlName]="ECHECK_FIELDS.checkname"
                placeholder="Name on the account"
                required>
            <mat-error *ngIf="formGroup?.controls?.[ECHECK_FIELDS.checkname]?.touched && formGroup?.controls?.[ECHECK_FIELDS.checkname]?.invalid">
                {{validationService.getFieldErrorMessage(ECHECK_FIELDS.checkname, formGroup.controls[ECHECK_FIELDS.checkname])}}
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="accountTypeEnabled" class="account-type" appearance="standard" floatLabel="always">
            <mat-label>{{ ECHECK_FIELDS.checktype }}</mat-label>
            <mat-select
                [formControlName]="ECHECK_FIELDS.checktype"
                required>
                <mat-option selected value="">-- Select One --</mat-option>
                <mat-option *ngFor="let accountType of ECHECK_ACCOUNTTYPELIST" [value]="accountType">
                    {{ accountType }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup?.controls?.[ECHECK_FIELDS.checktype]?.touched && formGroup?.controls?.[ECHECK_FIELDS.checktype]?.invalid">
                {{validationService.getFieldErrorMessage(ECHECK_FIELDS.checktype, formGroup.controls[ECHECK_FIELDS.checktype])}}
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="accountOwnerTypeEnabled" class="account-owner-type" appearance="standard" floatLabel="always">
            <mat-label>{{ ECHECK_FIELDS.checkowner }}</mat-label>
            <mat-select
                [formControlName]="ECHECK_FIELDS.checkowner"
                required>
                <mat-option selected value="">-- Select One --</mat-option>
                <mat-option *ngFor="let ownerType of ECHECK_ACCOUNTOWNERTYPELIST" [value]="ownerType">
                    {{ ownerType }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup?.controls?.[ECHECK_FIELDS.checkowner]?.touched && formGroup?.controls?.[ECHECK_FIELDS.checkowner]?.invalid">
                {{validationService.getFieldErrorMessage(ECHECK_FIELDS.checkowner, formGroup.controls[ECHECK_FIELDS.checkowner])}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard" floatLabel="always" class="vgs-iframe-field routing-number">
            <mat-label>{{ ECHECK_FIELDS.checkaba }} *</mat-label>
            <mat-icon matPrefix svgIcon="echeck-start"></mat-icon>
            <app-payment-integration-form-field
                formControlName="checkaba"
                [id]="'vgsRoutingNumber'"
                [loaded]="!loading"
                field-min-size="9">
            </app-payment-integration-form-field>
            <mat-error>
                {{ validationService.getFieldErrorMessage(ECHECK_FIELDS.checkaba, formGroup.controls.checkaba, formGroup.controls.checkaba.value?.error) }}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard" floatLabel="always" class="vgs-iframe-field account-number">
            <mat-label>{{ ECHECK_FIELDS.checkaccount }} *</mat-label>
            <mat-icon matPrefix svgIcon="echeck-start"></mat-icon>
            <app-payment-integration-form-field
                formControlName="checkaccount"
                [id]="'vgsAccountNumber'"
                [loaded]="!loading"
                field-min-size="4">
            </app-payment-integration-form-field>
            <mat-icon matSuffix svgIcon="echeck-end"></mat-icon>
            <mat-error>
                {{ validationService.getFieldErrorMessage(ECHECK_FIELDS.checkaccount, formGroup.controls.checkaccount, formGroup.controls.checkaccount.value?.error) }}
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="requireDualEntryForECheck" appearance="standard" floatLabel="always" class="vgs-iframe-field routing-number">
            <mat-label>{{ ECHECK_FIELDS.checkabavalidator }} *</mat-label>
            <mat-icon matPrefix svgIcon="echeck-start"></mat-icon>
            <app-payment-integration-form-field
                formControlName="checkabavalidator"
                [id]="'vgsRoutingNumberConfirm'"
                [loaded]="!loading"
                field-min-size="9">
            </app-payment-integration-form-field>
            <mat-error>
                {{ validationService.getFieldErrorMessage(ECHECK_FIELDS.checkabavalidator, formGroup.controls.checkabavalidator, formGroup.controls.checkabavalidator.value?.error) }}
            </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="requireDualEntryForECheck" appearance="standard" floatLabel="always" class="vgs-iframe-field account-number">
            <mat-label>{{ ECHECK_FIELDS.checkaccountvalidator }} *</mat-label>
            <mat-icon matPrefix svgIcon="echeck-start"></mat-icon>
            <app-payment-integration-form-field
                formControlName="checkaccountvalidator"
                [id]="'vgsAccountNumberConfirm'"
                [loaded]="!loading"
                field-min-size="4">
            </app-payment-integration-form-field>
            <mat-icon matSuffix svgIcon="echeck-end"></mat-icon>
            <mat-error>
                {{ validationService.getFieldErrorMessage(ECHECK_FIELDS.checkaccountvalidator, formGroup.controls.checkaccountvalidator, formGroup.controls.checkaccountvalidator.value?.error) }}
            </mat-error>
        </mat-form-field>
    </div>

    <div class="echeck-instructions">
        <div class="echeck-instructions__note">
            <teller-online-icon-info></teller-online-icon-info>
            <span>Where do I find Routing and Account Numbers?</span>
        </div>
        <img class="echeck-instructions__sample" src="assets/images/echeck_latest.png" alt="Sample check image">
    </div>

    <ng-container *ngIf="allowSavePaymentMethod && formGroup?.controls?.rememberPaymentMethod">
        <div class="remember-payment-method" formGroupName="rememberPaymentMethod">
            <mat-checkbox formControlName="checked">Save e-check information</mat-checkbox>
        </div>
    </ng-container>
</section>
